<template>
  <gj-modal
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      notFooterPadding
      @cancel="cancel"
      @confirm="confirm"
    >
    <template #header>应用到</template>
    <template #content>
      <div style="padding-bottom: 10px;">
          <div style="color: #666666;line-height: 24px">
            <span>模版名称 </span>
            <gj-text max-width="400px" style="color: #333333">{{item.name}}</gj-text></div>
          <div style="color: #666666; line-height: 24px">
            <span>规则 </span>
            <gj-text max-width="900px" style="color: #333333">{{getContent(item.expressionVO)}}</gj-text>
            <!-- <span style="color: #333333">{{getContent(item.expressionVO)}}</span> -->
          </div>
      </div>
      <app-base-main no-padding parentTable :table-shadow="false">
        
        <template #filter-group>
          <app-filter-group @reset="resetEvent()" @query="$gjQuery" :isBr="clientWidth > 1366 ? false : true">
            <gj-market-select
                initValue
                adMarket
                :clearable="false"
                v-model="filter.marketId"
                placeholder="全部站点"
                @input="marketChange($event)"
                width="130px"
            ></gj-market-select>
            <template v-if="activeName === 'adActivity'">
              <gj-search-input
              v-model="filter.adActivityStr"
              width="180px"
              placeholder="请输入广告活动名称"
            ></gj-search-input>
            </template>
            <template v-else>
              <gj-select
                  v-model="filter.campaignIds"
                  :options="option.campaignOption"
                  placeholder="全部广告活动"
                  type="multi-check"
                  :loading="option.campaignLoading"
                  @input="campaignChange($event)"
                  width="160px"
                  style="margin-left: 8px"
                ></gj-select>
                <gj-search-input

                v-model="filter.adGroupStr"
                width="180px"
                placeholder="请输入广告组名称"
              ></gj-search-input>
            </template>
           
            <!-- <gj-select
                v-model="filter.groupIds"
                :options="option.groupOption"
                :loading="option.groupLoading"
                placeholder="全部广告组"
                type="multi-check"
                width="160px"
            ></gj-select> -->
            <gj-select
                v-model="filter.same"
                :options="option.addOption"
                placeholder="是否有相似规则"
                width="140px"
            ></gj-select>
            <gj-select
                v-model="filter.adsStatus"
                :options="option.activeStatsOption"
                placeholder="活跃状态"
                width="140px"
            ></gj-select>
          </app-filter-group>
        </template>
        <template #table>
           <ad-apply-picker
              ref="adApplyPicker"
              name="adApplyPicker"
              :templateId="templateId"
              :form="filter"
              :executeObjectAdsType="executeObjectAdsType"
              :strategyType="strategyType"
              :isShowGroup="item.expressionVO.executeObjectAdsType === 'campaign' ? false : true"
              title="应用"
              @tabChange="changeTab"
          ></ad-apply-picker>
        </template>
       </app-base-main>
    </template>
    <template #footer>
       <gj-button @click="cancel">取消</gj-button>
      <gj-button :loading="confirmLoading" type="primary" @click="confirm">保存</gj-button>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, queryMixin} from "@/minxins";
import {getAdsAdjustStrategyLog, SP} from "@/api/ad";
import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
import AdApplyPicker from "./ad-apply-picker.vue";
import { getRuleContent, optionMap } from '../const'

export default {
  name: "ad-apply-template-modal",
  mixins: [modalMixIn, queryMixin],
  components: {
    AdApplyPicker
  },
  props: {
    templateId: {
      type: String,
      default: ''
    },
    executeObjectAdsType: {
      type: String,
      default: ''
    },
    strategyType: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
        filter: {
          marketId: null,
          campaignIds: [],
          groupIds: [],
          adsStatus: null,
          same: null,
          tableData2: [],
          adActivityStr: null,
          adGroupStr: null,
        },
        option: {
          campaignOption: [],
          campaignLoading: false,
          groupOption: [],
          groupLoading: false,
          addOption:[
            {id: "1", text: "是"},
            {id: "0", text: "否"},
          ],
          activeStatsOption: [
            {id: "1", text: "活跃"},
            {id: "0", text: "不活跃"},
          ],
         
        },
        activeName: 'adActivity',
        
    }
  },
  methods: {
      reset() {
          Object.assign(this.filter, {
            campaignIds: [],
            groupIds: [],
            adsStatus: null,
            same: null,
            adActivityStr: null,
            adGroupStr: null,
          })
        
      },
      $gjQuery() {
          this.$refs.adApplyPicker.updateData();
      },
      resetEvent() {
        this.reset();
        this.$nextTick(() => {
          this.$refs.adApplyPicker.selectReset();
        })
       
      },
       marketChange(marketId) {
        this.option.campaignLoading = true;
        this.option.campaignOption = [];
        this.filter.campaignIds = [];
        this.option.groupOption = [];
        this.filter.groupIds = [];
        SP.selectSpCampaigns({
          marketId
        })
          .then(({data}) => {
            this.option.campaignOption = data.map(e => ({
              id: e.campaignId,
              text: e.campaignName
            }));
          })
          .finally(() => this.option.campaignLoading = false);
      },
      campaignChange(campaignIds) {
        if (isMeaningless(this.filter.marketId)) {
          return;
        }
        this.option.groupOption = [];
        this.filter.groupIds = [];
        this.option.groupLoading = true;
        SP.selectSpGroups({
          marketId: this.filter.marketId,
          campaignIds: campaignIds,
          state: [0, 1]
        })
          .then(({data}) => {
            this.option.groupOption = data.map(e => ({
              id: e.groupId,
              text: e.groupName,
              bid: e.defaultBid
            }))
          })
          .finally(() => this.option.groupLoading = false);
      },
      confirm() {
        //先判断是否存在相似规则
        console.log('kndkldkl');
        if (this.isSimilarRule(this.filter.tableData2) === true) {
            const modal = this.$gjCreate('gj-info-modal', {
            props: {
              title: '提示',
              content: `选取的广告活动/组中，部分已存在【${optionMap[this.item.expressionVO.executeObjectAdsType]}-${optionMap[this.item.expressionVO.strategyType]}】的自动规则，当存在多个规则时，如满足执行条件，会同时执行，请确认是否继续添加？`
            },
            on: {
              cancel: () => modal.$gjDestroy(),
              confirm: () => {
                this.$emit('submit',this.filter.tableData2);
                modal.$gjDestroy()
              }
            }
          });
        }else {
           this.$emit('submit',this.filter.tableData2);
        }
         
      },
      getContent(item) {
        return getRuleContent(item);
      },
      changeTab(val) {
          this.activeName = val;
      },
      //是否包含相似规则
      isSimilarRule(array) {
        console.log(array);
        for (let i=0; i<array.length; i++) {
          let info = array[i];
          if (isMeaningful(info.sameRule) && info.sameRule.length > 0) {
              return true;
          }
        }
        return false;
      }
  }
}
</script>

<style lang="scss" scoped>
a{
  
}
</style>